<template>
  <div class="main" v-loading="loading">
    <el-scrollbar style="height:100%;" ref="scrollbar">
      <div class="header clearfix">
        <div class="qrcode-box">
          <div id="qrcode" ref="qrcode"></div>
        </div>
        <div class="hright">
          <h2>
            {{ companyStatus.nickName || '--' }}
            <!-- <div class="star ml-10">
              <div class="bg unstar" v-if="companyStatus.isCollect === '0'"></div>
              <div class="bg" v-else></div>
            </div> -->
          </h2>
          <div class="tags mt-15" v-if="companyStatus.source || companyStatus.constellation" >
              <span v-if="companyStatus.source" class="tag platform">{{ companyStatus.source === 'douyin' ? 'DY' : 'KS' }}</span>
              <span v-if="companyStatus.constellation !== '0'&&companyStatus.constellation!==null" class="tag constellation">{{ constellation(companyStatus.constellation) }}</span>
          </div>
          <el-row class="mt-15">
            <p>询盘账号： <span>{{companyStatus.uniqueId || '--'}}</span></p>
            <p>评论时间： <span>{{$moment(companyStatus.createTime * 1000).format('YYYY-MM-DD') || '--'}}</span></p>
            <p>评论点赞数： <span>{{companyStatus.awemeCount || '0'}}</span></p>
            <el-tooltip class="item" effect="dark" v-if="companyStatus.signature&&companyStatus.signature.length > 25" :content="companyStatus.signature" placement="top">
              <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width:80%;">签名： <span>{{companyStatus.signature}}</span></p>
            </el-tooltip>
            <p v-else style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width:80%;">签名： <span>{{companyStatus.signature || '--'}}</span></p>
          </el-row>
        </div>
      </div>
      <div style="height: 20px; background: #f1f2f4"></div>
      <div class="card-inquiry-data">
        <el-row :span="24">
          <el-col :span="24">询盘数据</el-col>
          <el-col :span="24" class="card-data-info">
            <p>视频源地址：
              <el-tooltip class="item" effect="dark" v-if="companyStatus.comDesc&&companyStatus.comDesc.length > 35" :content="companyStatus.comDesc" placement="top">
                <a :href="companyStatus.videoUrl" class="a-blue" referrerpolicy="no-referrer" target="_blank">{{ companyStatus.comDesc }}</a>
              </el-tooltip>
              <a v-else :href="companyStatus.videoUrl" class="a-blue" referrerpolicy="no-referrer" target="_blank">{{ companyStatus.comDesc || '--' }}</a>
            </p>
            <p>关键词内容： <span>{{ companyStatus.keyWord || '--' }}</span></p>
            <p style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width:80%;display:inline-block"><span class="card-data-inquiry-content">询盘内容</span>
              <el-tooltip class="item" effect="dark" v-if="companyStatus.text&&companyStatus.text.length > 25" :content="companyStatus.text" placement="top">
                <span>{{ companyStatus.text }}</span>
              </el-tooltip>
              <span v-else>{{ companyStatus.text || '--'}}</span>
            </p>
          </el-col>
        </el-row>
      </div>
      <div style="height: 20px; background: #f1f2f4"></div>
    </el-scrollbar>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'Enterprise',
  components: {
    // company,
  },
  data () {
    return {
      loading: true
    }
  },
  props: {
    companyStatus: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    companyStatus () {
      if (this.companyStatus) {
        this.$nextTick(() => {
          this.creatQrCode()
        })
      }
    }
  },
  computed: {

  },
  mounted () {
    setTimeout(() => {
      this.loading = false
    }, 2000)
    // this.$nextTick(() => {
    //   this.loading = false
    // })
  },
  methods: {
    creatQrCode () {
      const qrUrl = this.companyStatus.source === 'douyin' ? 'snssdk1128://user/profile/' : 'https://c.kuaishou.com/fw/user/'
      // eslint-disable-next-line no-unused-vars
      setTimeout(() => {
        this.$nextTick(() => {
          const qrcode = new QRCode(this.$refs.qrcode, {
            text: qrUrl + this.companyStatus.homePageUrl, // 需要转换为二维码的内容
            width: 100,
            height: 100,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        })
      }, 300)
    },
    constellation (val) {
      if (val) {
        if (val == 1) {
          return '白羊座'
        } else if (val == 2) {
          return '金牛座'
        } else if (val == 3) {
          return '双子座'
        } else if (val == 4) {
          return '巨蟹座'
        } else if (val == 5) {
          return '狮子座'
        } else if (val == 6) {
          return '处女座'
        } else if (val == 7) {
          return '天秤座'
        } else if (val == 8) {
          return '天蝎座'
        } else if (val == 9) {
          return '射手座'
        } else if (val == 10) {
          return '摩羯座'
        } else if (val == 11) {
          return '水瓶座'
        } else if (val == 12) {
          return '双鱼座'
        } else {
          return false
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.tagClass {
  color: #ab73ff;
  background: #f1edf9;
}
.main {
  /deep/ .el-scrollbar__view {
    padding-right: 15px;
    padding-bottom: 15px;
  }
  // width: 600px;
  /deep/ .el-tabs__nav {
    // .el-tabs__item {
    //   width: 140px;
    //   text-align: center;
    //   &.is-active {
    //     color: #5b96ec;
    //   }
    //   &:hover {
    //     color: #5b96ec;
    //   }
    // }
    // .el-tabs__active-bar {
    //   background-color: #5b96ec;
    // }
  }

  .card-inquiry-data {
    padding: 20px;
    background-color: #fff;

    .card-data-info {
      margin-top: 10px;
      padding: 10px;
      background-color: #fafafa;

      p {
        height: 40px;
        line-height: 40px;
        width: 500px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .card-data-inquiry-content {
        display: inline-block;
        width: 74px;
        height: 30px;
        line-height: 30px;
        margin-right: 20px;
        text-align: center;
        background-color: #e9f1ff;
        color: #4f7afd;
      }

      .a-blue {
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        color: #4f7afd;
      }
    }
  }

  .card-basics-data {
    padding: 20px;
    background-color: #fff;

    .card-data-info {
      margin-top: 10px;
      padding: 10px;
      background-color: #fafafa;

      p {
        display: inline-block;
        height: 40px;
        line-height: 40px;
      }

      .card-data-inquiry-content {
        display: inline-block;
        width: 74px;
        height: 30px;
        line-height: 30px;
        margin-right: 20px;
        text-align: center;
        background-color: #e9f1ff;
        color: #4f7afd;
      }
    }
    .won-the-praise-number {
      display: inline-block;
      height: 10px;
      background-color: rgb(15, 44, 209);
    }
    .attention-number {
      display: inline-block;
      height: 10px;
      background-color: rgb(15, 44, 209);
    }
    .fans-number {
      display: inline-block;
      height: 10px;
      background-color: rgb(15, 44, 209);
    }
  }
}
.tab {
  // height: 78px;
  background: #f0f2f5;
  .btn {
    display: inline-block;
    width: 110px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #333333;
    font-size: 16px;
    background: #d8dee7;
    margin-top: 28px;
  }
  .btn + .btn {
    border-left: 2px #fff solid;
  }
  .is-select {
    background: #fff;
    color: #1890ff;
  }
}
.header {
  display: flex;
  width: 100%;
  font-size: 12px;
  padding: 20px;
  background-color: #fff;
  .logo2 {
    float: left;
    width: 60px;
    height: 60px;
    padding: 6px;
    background-color: royalblue;
    font-weight: 400;
    color: #fff;
    text-align: center;
    font-size: 21px;
    line-height: 24px;
    border-radius: 4px;
    margin-right: 10px;
  }
  .logo {
    float: left;
    width: 60px;
    height: 60px;
    font-size: 0;
    // overflow: hidden;
    border-radius: 4px;
    margin-right: 10px;
    > img {
      width: 100%;
      object-fit: contain;
    }
  }
  .aliasLineHeight {
    line-height: 48px;
  }
  .hright {
    float: left;

    width: 584px;
  }
  h2 {
    font-size: 16px;
    font-weight: 400;

    .star {
      // float: left;
      display: inline-block;
      width: 20px;
      // height: 20px;
      position: relative;
      .bg {
        background-image: url("~@/assets/industry/star2.png");
        background-repeat: no-repeat;
        width: 20px;
        height: 20px;
        background-size: 100%;
        position: relative;
        top: 5px;
      }
      .unstar {
        background-image: url("~@/assets/industry/star.png");
      }
    }
  }
  .el-col-8 {
    // width: 265px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .el-col {
    > span {
      font-size: 12px;
    }
  }

  .qrcode-box {
    margin-right: 30px;
  }
}
.isurl {
  display: flex;

  a {
    display: block;
    color: #4f7afd;
  }
  .more {
    font-size: 12px;
    float: right;
    margin-left: 10px;
    color: #4f7afd;
    cursor: pointer;
  }
}
.address {
  .addressTT {
    display: inline-block;
    width: calc(100% - 60px);
    vertical-align: top;
  }
}

.componentTags {
  padding: 15px;
  padding-bottom: 5px;
  /deep/ .el-tag {
    cursor: pointer;
  }
  .el-button + .el-button {
    margin-left: 0;
  }
}
.enterpriseBody {
  // background: #fff;
  .tabfixed {
    background: #fff;
    &.fixed {
      position: fixed;
      top: 15px;
      width: 100%;
      max-width: 716px;
      z-index: 9;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 5px 0px;
    }
    // /deep/ .el-tabs__nav-prev {
    //   cursor: no-drop;
    //   &.is-disabled {
    //     cursor: pointer;
    //   }
    // }
    // /deep/ .el-tabs__nav-next {
    //   cursor: no-drop;
    //   &.is-disabled {
    //     cursor: pointer;
    //   }
    // }
  }
}
.mt-15 {
  p {
    height: 40px;
    line-height: 40px;
  }

  .platform {
    display: inline-block;
    width: 60px;
    height: 22px;
    line-height: 22px;
    margin-right: 10px;
    text-align: center;
    background: #ecf5fc;
    color: #51a4e7;
  }

  .constellation {
    display: inline-block;
    width: 60px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background-color: #f3f3fa;
  }
}
.content {
  padding: 24px;
  background-color: #fff;
}
</style>
